import { useState, useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { getMonolithApiHeaders } from '@udemy-v2/api-fetch';
export const enum CtaBehaviour {
  SUBS_FIRST = 'SUBS_FIRST',
  PURCHASE_FIRST = 'PURCHASE_FIRST',
  DYNAMIC = 'DYNAMIC',
}
export interface UseClpCtaBehaviourProps {
  courseId: string;
}

/**
 * Hook to fetch the CLP CTA behaviour for the current user and course from the legacy CLC API in the monolith.
 *
 * HACK HACK HACK - This hook also has a CRITICAL side effect of sending query params, including instructor referral
 * query params to the monolith backend which handles attribution downstream. There's currently no better way to do this,
 * and in order for this to work, we simply pass through the query params from the URL.
 *
 * @param courseId
 */
export function useClpCtaBehaviour({
  courseId
}: UseClpCtaBehaviourProps) {
  const [ctaBehaviour, setCtaBehaviour] = useState<CtaBehaviour | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const params = new URLSearchParams(window.location.search);
        params.set('components', 'cta_behaviour');
        const response = await fetch(`/api-2.0/course-landing-components/${courseId}/me/?${params.toString()}`, {
          method: 'GET',
          headers: {
            ...getMonolithApiHeaders(),
            'Content-Type': 'application/json'
          }
        });
        if (response.ok) {
          setCtaBehaviour((await response.json())?.cta_behaviour?.ctaBehaviour);
        } else {
          throw new Error(`Unable to retrieve CLP CTA behaviour: status ${response.status}: ${response.statusText}`);
        }
      } catch (err) {
        // The page can function even without the fetched CLP CTA behaviour.
        // In this case the purchase context will default to the subs-first behaviour.
        Sentry.captureException(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [courseId]);
  return {
    ctaBehaviour: ctaBehaviour,
    isLoading: isLoading
  };
}